function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { base } from '../variant/baseData';
export default (function (theme) {
  return _objectSpread({
    color: {
      // Shared palette colors between dark and light theme go here
      primary: theme.colors.primary['600'],
      black: theme.colors.black,
      white: theme.colors.white,
      error: theme.colors.error['600'],
      slate: theme.colors.info['600'],
      emerald: theme.colors.success['600'],
      amber: theme.colors.warning['600'],
      sapphire: theme.colors.quaternary['50'],
      grey10: theme.colors.secondary['700'],
      grey30: theme.colors.secondary['900'],
      grey50: theme.colors.secondary['500'],
      grey70: theme.colors.secondary['300'],
      grey90: theme.colors.secondary['100'],
      grey96: theme.colors.secondary['50']
    },
    font: {
      weight: theme.font.weight,
      family: theme.font.family,
      size: {
        xxs: theme.font.size.sm,
        xs: theme.font.size.md,
        sm: theme.font.size.lg,
        md: theme.font.size.xl,
        lg: theme.font.size['2xl'],
        xlg: theme.font.size['3xl'],
        xxlg: theme.font.size['4xl'],
        xxxlg: theme.font.size['5xl'],
        mxlg: theme.font.size['6xl'],
        mxxlg: theme.font.size['7xl'],
        mobile: {
          lg: theme.font.size.mobile['2xl'],
          xlg: theme.font.size.mobile['3xl'],
          xxlg: theme.font.size.mobile['4xl']
        }
      },
      lineHeight: {
        mobile: {
          lg: theme.font.lineHeight.mobile.lg,
          xlg: theme.font.lineHeight.mobile.xl,
          xxlg: theme.font.lineHeight.mobile['2xl']
        }
      }
    },

    /**
     * All values in spaces must follow 8px interval rule.
     * That is any value must have a 8px increment or decrement
     * from its neighbours.
     */
    spaces: {
      xs: theme.spaces.xs,
      sm: theme.spaces.sm,
      md: theme.spaces.md,
      lg: theme.spaces.lg,
      xlg: theme.spaces.xl,
      xxlg: theme.spaces['2xl']
    }
  }, base);
});